import React, { useEffect, useState } from 'react';
import { getRequest } from '../UrlRequest';
import DataChart from './DataChart'; 
import {useLocation} from 'react-router-dom'; //상태로 application 수신받고 url 분리용
import Loading from '../common/Loading';
import './Chart.css';

const BloodPressure = ({ patientId, selectedDate, selectedPeriod }) => {
  const [bloodPressureData, setBloodPressureData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const application = location.state?.application || 'hearton'; //기본값은 hearton으로 설정


  useEffect(() => {
    const fetchBloodPressureData = async () => {
      if (!patientId || !selectedDate) return;

      setLoading(true);                                                                                                                                                                                                                                                                                                                                                                                                     
      setError(null);

      try {
        const token = localStorage.getItem('accessToken');
        const response = await getRequest(application,
          `/doctor/${patientId}/blood-pressure/period?on-date=${selectedDate}&period=${selectedPeriod}`,
          token
        );

        if (response && response.systolics && response.diastolics) {
          setBloodPressureData(response); // 정상적으로 데이터를 저장
        } else {
          setError('해당 기간에 혈압 데이터가 없습니다.');
        }
      } catch (error) {
        setError('혈압 데이터를 불러오는 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchBloodPressureData();
  }, [application, patientId, selectedDate, selectedPeriod]);

  return (
    <div className="chartcontainer">
      {loading ? (
        <Loading message="혈압 데이터 로딩 중..." size="medium" />
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : bloodPressureData ? (
        <>
          <div className="chart-header">
            <h3 className="chart-title">혈압</h3>
            <div style={{ display: 'flex', gap: 'calc(16px * var(--scale-factor))' }}>
              <span className="chart-value">
                수축기:
                <strong>{bloodPressureData.systolics.slice(-1)[0]} mmHg</strong>
              </span>
              <span className="chart-value">
                이완기:
                <strong>{bloodPressureData.diastolics.slice(-1)[0]} mmHg</strong>
              </span>
            </div>
          </div>
          <div className="chart-wrapper">
            <DataChart
              patientId={patientId}
              dataType="blood-pressure"
              endpoint={`/doctor/${patientId}/blood-pressure/period`}
              label="수축기"
              multipleLines={true}
              selectedDate={selectedDate}
              selectedPeriod={selectedPeriod}
              chartLabels={bloodPressureData.dates}
              chartData={bloodPressureData.systolics}
              chartData2={bloodPressureData.diastolics}
              chartDummy={bloodPressureData.is_dummy}
            />
          </div>
        </>
      ) : (
        <p>{selectedDate}에 대한 혈압 데이터가 없습니다.</p>
      )}
    </div>
  );
};

export default BloodPressure;
